import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const STORAGE_KEY = 'sabotage_onboarded';

export default function OnboardingBanner() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg px-4 py-3 flex items-center gap-3 mb-4">
      <HelpCircle className="w-5 h-5 text-primary shrink-0" />
      <p className="text-sm text-muted-foreground flex-1">
        <strong className="text-foreground">New to Sabotage Fantasy?</strong>{' '}
        <button
          onClick={() => { dismiss(); navigate('/how-to-play'); }}
          className="text-primary hover:underline font-medium"
        >
          Learn how to play &rarr;
        </button>
      </p>
      <button
        onClick={dismiss}
        className="p-1 rounded text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
